import { Navigate, useLocation } from 'react-router';
import { LocalStorageService } from 'services';
import Pages from 'containers/layout/Pages';
import { ReactElement, ElementType } from 'react';
import {
  BreadcrumbConfig, RouteHideContext,
} from 'router/types';
import { User } from 'app/auth/types';
import { useAppSelector } from 'store/hooks';
import { selectAuthUser } from 'app/auth/selectors';

interface RouteMeta {
  id: number;
  menuItem?: boolean;
  menuParentId?: number | null;
}

interface PrivateRouteProps extends RouteMeta {
  component: ElementType;
  breadcrumb?: BreadcrumbConfig[];
  componentProps?: Record<string, unknown>;
  user?: User | null;
  hide?: (args: RouteHideContext) => boolean;
  claims?: unknown[] | null;
}

export const PrivateRoute = ({
  component,
  breadcrumb,
  componentProps = {},
  hide,
  ...rest
}: PrivateRouteProps): ReactElement => {
  const isSubMenu = rest.menuItem && rest.menuParentId;

  const user = useAppSelector(selectAuthUser);

  const activeMenuId: number = isSubMenu
    ? rest!.id
    : rest!.menuParentId ?? rest!.id;

  const isAuth = user && LocalStorageService.get('auth');
  const location = useLocation();

  return isAuth ? (
    <Pages
      breadcrumb={breadcrumb}
      hide={hide}
      component={component}
      activeMenu={activeMenuId}
      rest={{ ...componentProps }}
    />
  ) : (
    <Navigate replace to="/login" state={{ from: location.pathname + location.search }} />
  );
};
